__turbopack_context__.v({
  "assurance": "ContactSection-module__1kX6Bq__assurance",
  "assuranceDot": "ContactSection-module__1kX6Bq__assuranceDot",
  "badge": "ContactSection-module__1kX6Bq__badge",
  "badgeMark": "ContactSection-module__1kX6Bq__badgeMark",
  "bgGlowA": "ContactSection-module__1kX6Bq__bgGlowA",
  "bgGlowB": "ContactSection-module__1kX6Bq__bgGlowB",
  "bgGrain": "ContactSection-module__1kX6Bq__bgGrain",
  "bgGrid": "ContactSection-module__1kX6Bq__bgGrid",
  "bgLayer": "ContactSection-module__1kX6Bq__bgLayer",
  "card": "ContactSection-module__1kX6Bq__card",
  "cardCorner": "ContactSection-module__1kX6Bq__cardCorner",
  "cardHeader": "ContactSection-module__1kX6Bq__cardHeader",
  "cardKicker": "ContactSection-module__1kX6Bq__cardKicker",
  "cardTitle": "ContactSection-module__1kX6Bq__cardTitle",
  "cardTopline": "ContactSection-module__1kX6Bq__cardTopline",
  "checkBox": "ContactSection-module__1kX6Bq__checkBox",
  "checkBoxError": "ContactSection-module__1kX6Bq__checkBoxError",
  "checkInput": "ContactSection-module__1kX6Bq__checkInput",
  "consent": "ContactSection-module__1kX6Bq__consent",
  "consentLink": "ContactSection-module__1kX6Bq__consentLink",
  "consentText": "ContactSection-module__1kX6Bq__consentText",
  "control": "ContactSection-module__1kX6Bq__control",
  "controlError": "ContactSection-module__1kX6Bq__controlError",
  "docIcon": "ContactSection-module__1kX6Bq__docIcon",
  "docName": "ContactSection-module__1kX6Bq__docName",
  "docSize": "ContactSection-module__1kX6Bq__docSize",
  "docText": "ContactSection-module__1kX6Bq__docText",
  "dropHint": "ContactSection-module__1kX6Bq__dropHint",
  "dropIcon": "ContactSection-module__1kX6Bq__dropIcon",
  "dropTitle": "ContactSection-module__1kX6Bq__dropTitle",
  "dropzone": "ContactSection-module__1kX6Bq__dropzone",
  "dropzoneActive": "ContactSection-module__1kX6Bq__dropzoneActive",
  "dropzoneError": "ContactSection-module__1kX6Bq__dropzoneError",
  "errorMsg": "ContactSection-module__1kX6Bq__errorMsg",
  "field": "ContactSection-module__1kX6Bq__field",
  "form": "ContactSection-module__1kX6Bq__form",
  "grid": "ContactSection-module__1kX6Bq__grid",
  "heading": "ContactSection-module__1kX6Bq__heading",
  "headingAccent": "ContactSection-module__1kX6Bq__headingAccent",
  "infoBody": "ContactSection-module__1kX6Bq__infoBody",
  "infoIcon": "ContactSection-module__1kX6Bq__infoIcon",
  "infoItem": "ContactSection-module__1kX6Bq__infoItem",
  "infoLabel": "ContactSection-module__1kX6Bq__infoLabel",
  "infoList": "ContactSection-module__1kX6Bq__infoList",
  "label": "ContactSection-module__1kX6Bq__label",
  "lede": "ContactSection-module__1kX6Bq__lede",
  "left": "ContactSection-module__1kX6Bq__left",
  "mailLink": "ContactSection-module__1kX6Bq__mailLink",
  "mailStack": "ContactSection-module__1kX6Bq__mailStack",
  "optional": "ContactSection-module__1kX6Bq__optional",
  "preview": "ContactSection-module__1kX6Bq__preview",
  "previewDoc": "ContactSection-module__1kX6Bq__previewDoc",
  "previewImg": "ContactSection-module__1kX6Bq__previewImg",
  "previewImgWrap": "ContactSection-module__1kX6Bq__previewImgWrap",
  "previewMeta": "ContactSection-module__1kX6Bq__previewMeta",
  "previewName": "ContactSection-module__1kX6Bq__previewName",
  "previewScrim": "ContactSection-module__1kX6Bq__previewScrim",
  "previewSize": "ContactSection-module__1kX6Bq__previewSize",
  "removeBtn": "ContactSection-module__1kX6Bq__removeBtn",
  "req": "ContactSection-module__1kX6Bq__req",
  "row": "ContactSection-module__1kX6Bq__row",
  "rule": "ContactSection-module__1kX6Bq__rule",
  "ruleDot": "ContactSection-module__1kX6Bq__ruleDot",
  "ruleLine": "ContactSection-module__1kX6Bq__ruleLine",
  "section": "ContactSection-module__1kX6Bq__section",
  "select": "ContactSection-module__1kX6Bq__select",
  "shell": "ContactSection-module__1kX6Bq__shell",
  "spin": "ContactSection-module__1kX6Bq__spin",
  "submit": "ContactSection-module__1kX6Bq__submit",
  "submitIcon": "ContactSection-module__1kX6Bq__submitIcon",
  "submitLabel": "ContactSection-module__1kX6Bq__submitLabel",
  "submitSheen": "ContactSection-module__1kX6Bq__submitSheen",
  "submitWrap": "ContactSection-module__1kX6Bq__submitWrap",
  "textarea": "ContactSection-module__1kX6Bq__textarea",
});
